/*
 * Constants.
 */

/**
 * Mouse event button values.
 *
 * To be used with the MouseEvent.button property, not the MouseEvent.buttons property.
 *
 * https://www.w3.org/TR/uievents/#dom-mouseevent-button
 */
export enum MouseButtonsEnum {
  PRIMARY = 0,
  AUXILIARY = 1,
  SECONDARY = 2,
}
